import { ObjectValues } from '../../app/types/utilityTypes';

export const LID_LINE_CHART_TABS = {
  CHART: 'chart',
  TABLE: 'table',
} as const;

export type LidLineChartTabs = ObjectValues<typeof LID_LINE_CHART_TABS>;
